import { render } from "./CaseDescription.vue?vue&type=template&id=0bcfb05e&ts=true"
import script from "./CaseDescription.vue?vue&type=script&lang=ts"
export * from "./CaseDescription.vue?vue&type=script&lang=ts"

import "./CaseDescription.vue?vue&type=style&index=0&id=0bcfb05e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__